import React, { useMemo } from "react";
import { ITimelineSegment } from "../../../components/common/timeline/TimelineSegment";
import { formatValue } from "../../..//components/utils/common";
import { FormatType } from "../../..//entities/Metadata";
import { ReportedTimeByDay } from "../../../store/ReportedTimeStore";
import { getDaysBetweenDates } from "../../common/timeline/utils";

type Props = {
    reportedTime: ReportedTimeByDay;
    segment: ITimelineSegment;
    isTotal: boolean;

    expected?: number;
};

const ReportedTimeCell = (props: Readonly<Props>) => {
    const { reportedTime, segment, isTotal, expected } = props;

    const reported = useMemo(
        () =>
            getDaysBetweenDates(segment.startDate, segment.finishDate).reduce(
                (sum, date) => sum + (reportedTime[date.toISOString()] ?? 0),
                0
            ),
        [reportedTime, segment.startDate, segment.finishDate]
    );

    const isExceeded = expected !== undefined && !!reported && reported > expected;

    const className = [
        "time-tracking-cell",
        "fill-space",
        isTotal ? "total" : undefined,
        isExceeded ? "exceeded" : undefined
    ].join(" ");

    return (
        <div className={className}>
            <div className={`cell-content fill-space columns-${1}`}>
                <div className="value-wrap">
                    <div className="value">
                        {expected || isExceeded ? (
                            <>
                                {formatValue(reported!, FormatType.Duration)} of {formatValue(expected, FormatType.Duration)}
                            </>
                        ) : (
                            <>{reported ? formatValue(reported, FormatType.Duration) : "-"}</>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ReportedTimeCell);
